/**
* Extensions on classes of CreateJS
*  
* Created on 30-mrt-2017, 10:05:41
* @author Reinier Feijen for &ranj
**/

/**
 * Transforms the specified rect 
 * Analogous to DisplayObject.localToLocal (http://www.createjs.com/docs/easeljs/classes/DisplayObject.html#method_localToLocal)
 * @param Rectangle rect The rectangle in the source display object to transform.
 * @param DisplayObject target The target display object to which the coordinates will be transformed.
 * @param Rectangle rectOut Optional. An object to copy the result into. If omitted a new Rectangle will be returned.
 * @returns Rectangle Returns a Rectangle instance with x, y, width and height properties correlating to the transformed position in the target's coordinate space.
 */
createjs.DisplayObject.prototype.localToLocalRect = function(rect, target, rectOut)
{
    var p0 = this.localToLocal(rect.x,rect.y, target);
    var p1 = this.localToLocal(rect.x+rect.width,rect.y+rect.height, target);
    var r = rectOut || new createjs.Rectangle();
    r.setValues(Math.min(p0.x,p1.x), Math.min(p0.y,p1.y), Math.abs(p0.x-p1.x), Math.abs(p0.y-p1.y));
    return r;
}